// Eager and dependency-free on purpose: the always-mounted CookieConsent reads it, and so does the always-mounted
// TourManager (through tour/constants.ts), so it must not pull anything in with it.
//
// The one rule for "this page is a call": a live lesson, or the practice room that mirrors it. Both are
// full-screen rooms with the controls and the chat box along the bottom edge, so nothing may be laid over
// them and nothing may start a prompt there:
//   - the cookie banner (a fixed bar that covers the controls and whose link reloads the page, ending the
//     call) stays out and comes back once the person leaves (#1031);
//   - the tour never starts or carries on there (components/tour/constants.ts).
// The next full-screen room is one more alternative below, and both follow. (The puzzle player,
// /student/puzzles/:packId behind the puzzle_playground flag, has the same layout: add it here when that
// flag turns on.)
//
// The room itself and anything below it count, so a trailing slash cannot slip through: the router serves
// /student/practice-room/ as the page. The bare /student/live-session (no lesson id, so no page) matches too,
// as it always did for the tour.
const CLASSROOM_PATH = /^\/(student|tutor)\/(live-session|practice-room)(\/|$)/;

export function isClassroomPath(pathname: string): boolean {
  return CLASSROOM_PATH.test(pathname);
}
